export const CREATING_ACCOUNTABILITY_TEMPLATE = 'Creating Accountability Template';
export const RETRIEVING_ACCOUNTABILITY_TEMPLATE = 'Retrieving Accountability Template';
export const UPDATING_ACCOUNTABILITY_TEMPLATE = 'Updating Accountability Template';
export const GENERATING_SESSIONS = 'Generating Sessions';
